module.exports = __webpack_public_path__ + "media/images/flags/EC-c9775806e63b5ac5702e8c5f405f739f.svg";